import * as CL from '@design-system/component-library';
import { t } from '../../../common/i18n';

export interface StepErrorItem {
  text: string;
  id: string;
}

export interface StepErrorProps {
  errors?: StepErrorItem[];
  className?: string;
}

export const StepError = ({ errors, className }: StepErrorProps) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <CL.ErrorSummary
      className={className}
      i18n_errorSummary_formHasErrorsTitleText={
        errors.length === 1
          ? t.EPHQ('Check and correct the following field:')
          : t.GAML('Check and correct the following {} fields:', errors.length.toString())
      }
    >
      {errors.map((error, index) => (
        <CL.Link key={index} linkHref={`#${error.id}`}>
          {error.text}
        </CL.Link>
      ))}
    </CL.ErrorSummary>
  );
};
